// extracted by mini-css-extract-plugin
export default {"container":"S06_container__k03Kz","limiter":"S06_limiter__7eHQh","sub":"S06_sub__WEi9E","title":"S06_title__zd5bB","text":"S06_text__xBOps","linkBtn":"S06_linkBtn__JlktX"};